import React, { Fragment, useState, useEffect, Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import GeneralSummary from './GeneralSummary';
import Loader from '../../../../../Layout/Loader';
import TreatmentMapped from './TreatmentMapped';
import Scheduled from './Scheduled';


const Summary = ({permission}) => {

  console.warn(permission)
  const [currentTab, setCurrentTab] = useState('summary');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const tab = location.pathname.split('/').pop();
    setCurrentTab(tab);
  }, [location]);

  const {data} = location.state || {}

  return (
    <Suspense fallback={<Loader/>}>
      <div className="generalsummary" id="generalsummary">
        <GeneralSummary data={data} />
        <div className="">
         <TreatmentMapped permission={permission}/>
        </div>
        <div>
           <Scheduled permission={permission}/>
          </div>
      </div>
      {/* <ToastContainer /> */}
    </Suspense>
  );
};

export default Summary;
